import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                                <section>
                                    <div className="">
                                        <div className="ilead-rgt task">
                                            <div className="innerpadding">


                                                <div className="ilead-contentarea">
                                                    <div className="circle_title-first"><img
                                                        src={require('@images/Browndot.png')}
                                                        alt=""/>THINGS TO CONSIDER AT EACH STAGE OF THE PROCESS</div>

                                                    <ol className="brownbullet-list listcontentSpacing uiheading">
                                                        <li className="li_bottom_padding"><p>Pre goal-setting
                                                            planning</p>
                                                            <ul className="greenbullet-list uiheading">
                                                                <li><p>Think about what you want – what is your desired
                                                                    outcome?</p></li>
                                                                <li><p>Why do you want it?</p></li>
                                                                <li><p>Think about whether you should want it – is it
                                                                    worthwhile?</p></li>
                                                                <li><p>Weigh up benefits and costs of your outcome.</p>
                                                                </li>
                                                                <li><p>Consider past experience.</p></li>
                                                            </ul>
                                                        </li>
                                                        <li className="li_bottom_padding"><p>Goal-setting</p>
                                                            <ul className="greenbullet-list uiheading">
                                                                <li><p>Set a target that is SMART. </p></li>
                                                                <li><p>Specific | Measured | Agreed | Realistic |
                                                                    Timed.</p></li>

                                                            </ul>
                                                        </li>
                                                        <li className="li_bottom_padding"><p>Plan how to get there</p>
                                                            <ul className="greenbullet-list uiheading">
                                                                <li><p>Think about what needs to be done to meet your
                                                                    target.</p></li>
                                                                <li><p>Break down your target into manageable chunks if
                                                                    it makes it easier.</p></li>
                                                                <li><p>Prioritise; what is most important?</p></li>
                                                                <li><p>Think about what resources you will need to help
                                                                    you achieve your goal.</p></li>
                                                                <li><p>Consider the barriers to your goal – what is
                                                                    likely to stop you from attaining it?</p></li>
                                                            </ul>
                                                        </li>
                                                        <li className="li_bottom_padding"><p>Take action</p></li>
                                                        <li className="li_bottom_padding"><p> Review actions and adjust
                                                            strategies</p>
                                                            <ul className="greenbullet-list uiheading">
                                                                <li><p>Take some time to review whether things are going
                                                                    to plan.</p></li>
                                                                <li><p>If things are not going to plan, consider why
                                                                    this is the case.</p></li>
                                                                <li><p>Take stock of new information or changes to the
                                                                    situation.</p></li>
                                                                <li><p>Be flexible and ready to rethink your strategy,
                                                                    if need be.</p></li>
                                                                <li><p>Be resilient – don’t be disheartened if you don’t
                                                                    get it right first time.</p></li>
                                                            </ul>
                                                        </li>
                                                        <li className="li_bottom_padding"><p> Achieve target</p>
                                                        </li>
                                                        <li className="li_bottom_padding"><p> Evaluate outcomes</p>
                                                            <ul className="greenbullet-list">
                                                                <li><p>Congratulate yourself if you have achieved the
                                                                    desired outcome.</p></li>
                                                                <li><p>Consider what you could have done
                                                                    differently. </p></li>
                                                                <li>
                                                                    <div><p>Think about your key learning for:</p></div>

                                                                    <p><span className="brown brownbold">&gt;</span>Your
                                                                        outcomes</p>
                                                                    <p><span className="brown brownbold">&gt;</span>Your
                                                                        action planning process</p>
                                                                </li>
                                                                <li><p>How can you incorporate your learning into your
                                                                    next action plan?</p></li>
                                                            </ul>
                                                        </li>
                                                    </ol>
                                                    <p></p>

                                                    <div className="circle_title"><img
                                                        src={require('@images/Browndot.png')}
                                                        alt=""/>WHAT IS A SMART TARGET?</div>
                                                    <p>SMART targets<a className="superscripttext"
                                                                       href="further_info.php?course=300"><sup>1</sup></a> are
                                                        a very simple concept and in recent years have become one of the
                                                        most
                                                        popular ways of breaking down goals into measurable chunks.
                                                        There are a number of differing
                                                        opinions as to what SMART actually stands for. Here, we have
                                                        outlined them all and explained the
                                                        most popular. These steps are relevant whether you are setting
                                                        your own target, or a target for
                                                        an employee.</p>


                                                    <div className="left-btn">
                                                        <div
                                                            onClick={this.props.handleChangePage('Page2')}
                                                            className="button-next-previous-done task">&lt;&lt; Previous
                                                        </div>
                                                    </div>
                                                    <div className="right-btn">
                                                        <div
                                                            onClick={this.props.handleChangePage('Page4')}
                                                            className="button-next-previous-done task">Next &gt;&gt;</div>
                                                    </div>

                                                </div>

                                            </div>


                                        </div>


                                    </div>
                                </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}